import { safeFetch } from "../utils/safeFetch";

const request = async (path, token, tenant, options = {}) => {
  const response = await safeFetch(`/api/fixed-price-menus${path}`, {
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    let message = text;
    try {
      message = JSON.parse(text)?.error || text;
    } catch {
      // Keep the response text when it is not JSON.
    }
    const error = new Error(message || `HTTP error! status: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return null;
  return response.json();
};

export const getAllFixedPriceMenus = (token, tenant) =>
  request("", token, tenant);

export const getActiveFixedPriceMenu = async (date, token, tenant) => {
  try {
    return await request(`/active-for-date?date=${encodeURIComponent(date)}`, token, tenant);
  } catch (error) {
    if (error.status === 404) return null;
    throw error;
  }
};

export const createFixedPriceMenu = (payload, token, tenant) =>
  request("", token, tenant, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateFixedPriceMenu = (menuId, payload, token, tenant) =>
  request(`/${menuId}`, token, tenant, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deactivateFixedPriceMenu = (menuId, token, tenant) =>
  request(`/${menuId}/deactivate`, token, tenant, {
    method: "PATCH",
  });

export const deleteFixedPriceMenu = (menuId, token, tenant) =>
  request(`/${menuId}`, token, tenant, {
    method: "DELETE",
  });
